import React, { Component } from 'react'
import "../css/general-style.css"
import '../css/table-responsive.css'
import "../css/dashboard.css"
import { Menu } from "../components/Menu/Menu";
import LoadingWindow from '../components/LoadingWindow';
import { AiFillFileImage, AiOutlineCloudUpload, AiFillDollarCircle, AiFillCreditCard, AiFillFileExcel, AiOutlineReload, AiOutlineSave, AiOutlineDownload } from "react-icons/ai"
import { BsBoxSeam } from "react-icons/bs"
import { FiPlus } from "react-icons/fi"
import LineAreaGraph from '../components/LineAreaGraph'
import { pricesFormat } from '../functions/pricesFormat';
import Swal from "sweetalert2";
import { confirmCloseAlert } from '../functions/alerts'
import { getValueCookie } from '../services/cookieService';
import { getActualDateUTC, getDateFromReports } from '../functions/dateFormat';
import { create_Delete_Update_Information, getInformationWithData, uploadFile } from '../services/CABE';
import SearchItemName from '../components/SearchItemName';
import { getIndexElement } from '../functions/searchInObject';
import ExcelDocument from '../components/ExcelDocument';
import { getDataSet } from '../functions/generateDataSetExcel';
import { getPrintHeaderCompany } from '../functions/companyInformation';
import { PriceListModal } from '../components/PriceList/PriceListModal';
import { resizeFile } from '../functions/reSizeImg';
import Catalogue2NoPrices from '../components/Catalogue2.0/Catalogue2NoPrices.js';

export default class Inventory extends Component {

    constructor(props) {
        super(props)
        this.LineAreaGraph1 = React.createRef()
        this.ModalLoading = React.createRef();
    }

    state = {
        companyPrintHeader: getPrintHeaderCompany(),
        Catalogue: [],
        Product: {
            itemCode: "",
            LastTotalUnitCost: 0,
            ShipWeight: "",
            StandardUnitCost: 0,
            UnitPrice: 0,
            abbreviatedDesc: "",
            caseupc: '',
            quantity: 0,
            upc: '',
            upc2: '',
            itemURLImage: '',
            isUpdateImg: false
        },
        FileInfo: {
            Name: '',
            File: null
        },
        Warehouse: getValueCookie('SubCompanyId') ? '003' : '000',
        PriceLevel: getValueCookie('SubCompanyId') ? '1' : undefined,
        selectOptions2: [
            { value: '003', label: 'B&B Miami Warehouse Price Level 4' },//4
            { value: '004', label: 'B&B Atlanta Warehouse Price Level 5' }//5
        ]
    }

    componentDidMount() {
        // this.LineAreaGraph1.current.setTitle('Quantity sold per month year 2022')
        // this.LineAreaGraph1.current.setLabels(['January', 'February', 'March', 'April', 'May', 'June'])
        // this.LineAreaGraph1.current.setData(['123', '100', '12', '156', '145', '110'])
    }

    selectInputFile() {
        var button = document.getElementById('formFileInventoryInformation')
        if (button) {
            button.click()
        }
    }
    //id='UPCInventoryInfo'

    onTarget = async (e) => {

        // Max 5 mb image size validation
        const maxSizeInMB = 3; // 5MB limit
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        if (e.target.files[0].size > maxSizeInBytes) {
            alert(`File too large. Maximum size is ${maxSizeInMB}MB`);
            return;
        }

        const id = e.target.id
        switch (id) {
            case "formFileInventoryInformation":
                if (e.target.files.length > 0) {
                    const pattern = /^image/

                    if (pattern.test(e.target.files[0].type)) {
                        const temporal = this.state.FileInfo
                        temporal.Name = e.target.files[0].name
                        temporal.File = await resizeFile(e.target.files[0],375,404, 0.5)
     
                        this.setState({ FileInfo: temporal })
                    } else {
                        confirmCloseAlert('incorrect', 'The File is not a image please upload a correct File!')
                        this.setState({
                            FileInfo: {
                                Name: '',
                                File: null
                            }
                        })
                    }
                }

                break;
            default:
                break;
        }
    }

    async onKeyDown() {
        const updatedProduct = this.state.Product;
        let data = {
            ItemCode: this.state.Product.itemCode,
            idCompany: Number(getValueCookie('CompanyId')),
            upc: updatedProduct.upc,
            upc2: updatedProduct.upc2,
            caseupc: updatedProduct.caseupc
        }
        const newUpc = document.getElementById('UPCInventoryInfo').value
        const newUpc2 = document.getElementById('UPC2InventoryInfo').value 
        const newCaseupc = document.getElementById('CaseUPCInventoryInfo').value

        if (newUpc !== data.upc) {
            updatedProduct.upc = newUpc;
            data.upc = newUpc;
        }
        if (newUpc2 !== data.upc2) {
            updatedProduct.upc2 = newUpc2;
            data.upc2 = newUpc2;
        }
        if (newCaseupc !== data.caseupc) {
            updatedProduct.caseupc = newCaseupc;
            data.caseupc = newCaseupc;
        }
        
        
        await this.UpdateUpc(data);
        this.setState({ Product: updatedProduct });
    }

    async UpdateUpc(data) {
        const result = await create_Delete_Update_Information('/Items/update', data)
        if (result.status.code === 1) {
            this.updateProduct(true, data)
        } else {
            confirmCloseAlert('incorrect', 'Whoops, something is wrong. Please try again! If the result is the same call System Support')
        }
    }

    updateProduct(condition, data){
        document.getElementById('UPCInventoryInfo').value = data.upc
        document.getElementById('UPC2InventoryInfo').value = data.upc2
        document.getElementById('CaseUPCInventoryInfo').value = data.caseupc
        // this.enableUPCInput('UPCInventoryInfo', true, condition)
        // this.enableUPCInput('UPC2InventoryInfo', true, condition)
        // this.enableUPCInput('CaseUPCInventoryInfo', true, condition)
    }

    updateUPCInputs(condition) {
        document.getElementById('UPCInventoryInfo').value = this.state.Product.upc
        document.getElementById('UPC2InventoryInfo').value = this.state.Product.upc2
        document.getElementById('CaseUPCInventoryInfo').value = this.state.Product.caseupc
        this.enableUPCInput('UPCInventoryInfo', true, condition)
        this.enableUPCInput('UPC2InventoryInfo', true, condition)
        this.enableUPCInput('CaseUPCInventoryInfo', true, condition)
    }

    enableUPCInput(id, condition, firstCharge) {
        var obj = document.getElementById(id)
        if (id === 'UPCInventoryInfo' || id === 'UPC2InventoryInfo') {
            if (obj) {
                obj.disabled = condition
                if (!condition) {
                    obj.value = ''
                }

            }
        } else {
            if ((id === 'CaseUPCInventoryInfo' && getValueCookie('TypeUser') === '1') || firstCharge) {
                if (obj) {
                    obj.disabled = condition
                    if (!condition) {
                        obj.value = ''
                    }

                }
            } else {
                confirmCloseAlert('incorrect', 'Your user does not have the permissions to perform this action!')
            }
        }

    }

    onChangeSelects = async (e, id) => {

        switch (id) {
            case "Warehouse":
                this.changePriceLevel(e.value)
                this.setState({ Warehouse: e.value })
                break;
            default:
                break;
        }
        await this.getProducts()


    }

    changePriceLevel(id) {
        switch (id) {
            case "003":
                this.setState({ PriceLevel: '4' })
                break;
            case "004":
                this.setState({ PriceLevel: '5' })
                break;

            default:
                break;
        }
    }

    async updateImage() {


        let imgPreview = ''
        if (this.state.FileInfo.File !== null) {
            imgPreview = URL.createObjectURL(this.state.FileInfo.File)
        }

        Swal.fire({
            title: 'Do you want to upload this image?',
            html: 
            `<div class='ConfirmUpload'>
                <img src=${imgPreview !== '' ? imgPreview : '/assets/notavailable.png'} alt='Company' />
            </div>`,
            showCancelButton: true,
            confirmButtonText: 'Upload',
        }).then(async (result) => {

            if (result.isConfirmed) {
                this.ModalLoading.current.showState(true);
                const temporal = this.state.Product
                const data = {
                    ItemCode: temporal.itemCode,
                    idCompany: Number(getValueCookie('CompanyId')),
                    date: getActualDateUTC(),
                    createBy: getValueCookie('userName')
                }
                let formdata = new FormData()
                const blob = new Blob([JSON.stringify(data)], {
                    type: 'application/json'
                });
                await formdata.append('file', this.state.FileInfo.File, this.state.FileInfo.Name)
                await formdata.append("document", blob)
                
                const result2 = await uploadFile('/Items/updateImg', formdata, data)
                if (result2.status.code === 1) {
                    const bypassCache = new Date().getTime()
                    temporal.itemURLImage = `${result2.data[0].URL}?${bypassCache}`
                    await this.setState({
                        Product: temporal,
                        FileInfo: {
                            Name: '',
                            File: null
                        }
                    })

                    confirmCloseAlert('correct', 'The image for the Product: \n' + temporal.itemCode + '\nwas uploaded successfully')
                } else {
                    confirmCloseAlert('incorrect', 'Whoops, something is wrong. Please try again! If the result is the same call System Support')
                }


                this.ModalLoading.current.showState(false);
            }
        })
    }

    async getProducts() {
        const data = {
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
            priceLevel: this.state.PriceLevel,
            Component: null
        }
        const respuesta = await getInformationWithData('/Items/get', data);
        if (getValueCookie('CompanyId') === '6') {
            data.company = 'Mayaland Atlanta'
            data.idcompany = '3'
            const respuesta2 = await getInformationWithData('/Items/get', data);

            if (getValueCookie('CompanyId') === '6' && data.priceLevel !== '2') {
                for (const item of respuesta2.data) {

                    if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
                        //let p = item.LastTotalUnitCost / (0.95)
                        //item.UnitPrice = Number(pricesFormat(p / (0.65)))
                        item.UnitPrice = Number(pricesFormat(item.UnitPriceALT))

                    } else {
                        //ELIMINAR DEL CATALOGO

                    }
                }

            }
            respuesta.status.code = respuesta2.status.code
            //respuesta.data = respuesta.data.concat(respuesta2.data)
            for (const item of respuesta2.data) {
                item.IdCompany = 3
                item.LastTotalUnitCost=Number((item.LastTotalUnitCost/0.95).toFixed(2))
                const index = getIndexElement(respuesta.data, 'itemCode', item.itemCode)
                if (index !== -1) {
                    await respuesta.data.splice(index, 1)
                }
            }
            for (const item of respuesta.data) {
                item.IdCompany = 6
                if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
                    //let p = item.LastTotalUnitCost / (0.95)
                    //item.UnitPrice = Number(pricesFormat(p / (0.65)))
                    item.UnitPrice = Number(pricesFormat(item.UnitPriceALT))

                }
            }

            respuesta.data = respuesta.data.concat(respuesta2.data)
        }


        if (respuesta.status.code === 1 && respuesta.data) {
          
            this.setState({ Catalogue: respuesta.data })
        }
        await this.clickExcel()
    }

    clickExcel() {
        let button = document.getElementById('ExcelInventoryData')
        if (button) {
            button.click()
        }
    }

    async Synchronization() {
        this.ModalLoading.current.showState(true);
        const info = {
            IdCompany: Number(getValueCookie('CompanyId'))
        }

        const data = await getInformationWithData('/Items/sync', info)



        if (data.status.code === 1) {
            confirmCloseAlert('correct', `The products has been Synchronized.\nQuantity of Synchronized products: ${data.data.sincronizados}\nQuantity of items created: ${data.data.Creados}`)

        } else {
            //ERROR EN LA SINCRONIZACIÓN
            confirmCloseAlert('incorrect', `Whoops We have a error. Please try again!`)

        }
        this.ModalLoading.current.showState(false);
    }


    render() {
        const hasProduct = !!this.state.Product.itemCode;
        const isSergio   = getValueCookie('userName') === 'sergio.lopez';
        const isMayaland = getValueCookie('CompanyId') === '3';

        // field helper
        const Field = ({ label, id, suffix, defaultValue, disabled = false, type = 'text', onChange }) => (
            <div className="row mb-2">
                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '4px' }}>
                    {label}
                </label>
                <div className="input-group" style={{ borderRadius: '8px', overflow: 'hidden', border: '1.5px solid #E2E8F0' }}>
                    <input
                        type={type}
                        id={id}
                        defaultValue={defaultValue}
                        disabled={disabled}
                        onChange={onChange}
                        onKeyDown={!disabled ? this.onKeyDown : undefined}
                        style={{ border: 'none', padding: '0.6rem 0.875rem', fontSize: '0.9375rem', flex: 1, outline: 'none' }}
                    />
                    {suffix && (
                        <span style={{ background: '#F8FAFC', border: 'none', borderLeft: '1.5px solid #E2E8F0', padding: '0 0.875rem', display: 'flex', alignItems: 'center', fontSize: '0.8125rem', color: '#64748B', fontWeight: 600 }}>
                            {suffix}
                        </span>
                    )}
                </div>
            </div>
        );

        return (
            <div className="dash-page container-fluid pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div className="container-fluid" style={{ paddingTop: '1.5rem' }}>

                    {/* ── Hero ──────────────────────────────────────────── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                        borderRadius: '16px',
                        padding: '2rem 2.5rem',
                        marginBottom: '2rem',
                        marginTop: '2rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '1rem',
                    }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                                <BsBoxSeam style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                                <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                    Product Information
                                </h2>
                            </div>
                            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                                {hasProduct
                                    ? `Viewing: ${this.state.Product.itemCode} · ${this.state.Product.abbreviatedDesc}`
                                    : 'Search, browse and manage your product catalogue · ' + getValueCookie('Company')
                                }
                            </p>
                        </div>
                        <a
                            href="/inventory/add-new-product"
                            style={{
                                background: 'rgba(255,255,255,0.15)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                borderRadius: '10px',
                                color: 'white',
                                textDecoration: 'none',
                                padding: '0.6rem 1.25rem',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.4rem',
                            }}
                        >
                            <FiPlus /> New Product
                        </a>
                    </div>

                    {/* ── Action bar: search left · buttons right · same height ── */}
                    <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'stretch', marginBottom: '1.5rem', flexWrap: 'wrap' }}>

                        {/* Search — grows to fill space */}
                        <div style={{ flex: 1, minWidth: '220px' }}>
                            <SearchItemName disabled={false} priceLevel={this.state.PriceLevel} Padre={this} />
                        </div>

                        {/* Right side buttons — all same height via align-items:stretch */}
                        <div style={{ display: 'flex', gap: '0.625rem', alignItems: 'stretch', flexShrink: 0, flexWrap: 'wrap' }}>

                            {isMayaland && (
                                <PriceListModal
                                    id={"PriceLevelList"}
                                    colorButton="purpleButton"
                                    title="Generate Price Level List"
                                    hidden={false}
                                    disabled={false}
                                    titleButton='Print Price Levels'
                                />
                            )}

                            {isMayaland && (
                                <>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            Swal.fire({
                                                title: 'Download Inventory?',
                                                text: 'This will export all product data to an Excel file.',
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#1e3a8a',
                                                cancelButtonColor: '#94A3B8',
                                                confirmButtonText: 'Yes, download',
                                                cancelButtonText: 'Cancel',
                                            }).then(result => { if (result.isConfirmed) this.getProducts(); })
                                        }
                                        style={{
                                            background: '#F1F5F9',
                                            border: '1.5px solid #E2E8F0',
                                            borderRadius: '10px',
                                            color: '#334155',
                                            padding: '0 1.25rem',
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.4rem',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        <AiOutlineDownload /> Inventory
                                    </button>
                                    <ExcelDocument
                                        hidden={true}
                                        id={"ExcelInventoryData"}
                                        data={
                                            getValueCookie('TypeUser') === '1'
                                                ? getDataSet(this.state.Catalogue, ['Item Code', 'Product Line', 'Description', 'On Hand', 'Last Total Unit Cost', 'Unit Price', 'UPC', 'UPC 2', 'CASE UPC'], ['itemCode', 'ProductLineDesc', 'abbreviatedDesc', 'quantity', 'LastTotalUnitCost', 'UnitPrice', 'upc', 'upc2', 'caseupc'])
                                                : getDataSet(this.state.Catalogue, ['Item Code', 'Product Line', 'Description', 'On Hand'], ['itemCode', 'ProductLineDesc', 'abbreviatedDesc', 'quantity'])
                                        }
                                        sheetname={"Inventory"}
                                        archname={"INVENTORY COMPANY " + getValueCookie('Company') + " DATE " + getDateFromReports()}
                                    />
                                </>
                            )}

                            <Catalogue2NoPrices
                                PriceLevel={this.state.PriceLevel}
                                nombrePadre={'ProductInformation'}
                                Array={'Catalogue'}
                                Padre={this}
                                titleButton='Browse Catalogue'
                                needPrice={getValueCookie('SalesPerson') !== '0010'}
                                needCost={getValueCookie('SalesPerson') === '0010'}
                                productList={'ProductList'}
                            />
                        </div>
                    </div>

                    {/* ── Empty state ───────────────────────────────────── */}
                    {!hasProduct && (
                        <div style={{ textAlign: 'center', padding: '5rem 2rem', color: '#94A3B8' }}>
                            <BsBoxSeam style={{ fontSize: '3.5rem', marginBottom: '1rem', opacity: 0.3 }} />
                            <p style={{ margin: 0, fontSize: '1rem', color: '#64748B' }}>
                                Search a product above or <strong style={{ color: '#1e3a8a' }}>browse the catalogue</strong> to get started.
                            </p>
                        </div>
                    )}

                    {/* ── Product detail ────────────────────────────────── */}
                    {hasProduct && (
                        // key forces remount when product changes → defaultValue inputs reset correctly
                        <div className="row g-4" key={this.state.Product.itemCode}>

                            {/* ── LEFT: Image card ── */}
                            <div className="col-sm-12 col-lg-3">
                                <div className="card" style={{ borderRadius: '16px', border: '1px solid #E2E8F0', height: '100%' }}>
                                    <div className="card-body d-flex flex-column align-items-center justify-content-center" style={{ padding: '2rem 1.5rem' }}>
                                        <img
                                            key={this.state.Product.itemURLImage}
                                            id='PrincipalImgInventory'
                                            src={this.state.Product.itemURLImage || '/assets/notavailable.png'}
                                            alt={this.state.Product.abbreviatedDesc}
                                            style={{ width: '100%', maxWidth: '220px', borderRadius: '12px', objectFit: 'contain', marginBottom: '1.5rem' }}
                                        />

                                        <button
                                            onClick={() => this.selectInputFile()}
                                            type="button"
                                            style={{
                                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                                border: 'none', borderRadius: '10px', color: 'white',
                                                padding: '0.625rem 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                                                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center',
                                            }}
                                        >
                                            <AiFillFileImage /> Upload Image
                                        </button>
                                        <input accept="image/*" hidden type="file" id="formFileInventoryInformation" onChange={this.onTarget} />

                                        {this.state.FileInfo.Name !== '' && (
                                            <div style={{ marginTop: '1rem', textAlign: 'center', width: '100%' }}>
                                                <p style={{ fontSize: '0.78rem', color: '#64748B', marginBottom: '0.75rem' }}>
                                                    {this.state.FileInfo.Name}
                                                </p>
                                                <button
                                                    onClick={() => this.updateImage()}
                                                    type="button"
                                                    style={{
                                                        background: '#F0FDF4', border: '1.5px solid #86EFAC', borderRadius: '10px',
                                                        color: '#166534', padding: '0.6rem 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                                                        cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center',
                                                    }}
                                                >
                                                    <AiOutlineCloudUpload /> {this.state.Product.itemURLImage ? 'Update' : 'Upload'}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* ── RIGHT: Info card ── */}
                            <div className="col-sm-12 col-lg-9">
                                <div className="card" style={{ borderRadius: '16px', border: '1px solid #E2E8F0' }}>

                                    {/* ── Card header ── */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                        borderRadius: '16px 16px 0 0',
                                        padding: '1.5rem 2rem',
                                        color: 'white',
                                    }}>
                                        {/* Badges row */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.75rem' }}>
                                            {/* Item Code */}
                                            <span style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.5px' }}>
                                                {this.state.Product.itemCode}
                                            </span>
                                            {/* On Hand */}
                                            <span style={{ background: 'rgba(16,185,129,0.25)', border: '1px solid rgba(16,185,129,0.5)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 700 }}>
                                                On Hand: {this.state.Product.quantity || 0}
                                            </span>
                                            {/* Product Line */}
                                            {(this.state.Product.ProductLine || this.state.Product.ProductLineDesc) && (
                                                <span style={{ background: 'rgba(139,92,246,0.25)', border: '1px solid rgba(139,92,246,0.5)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 600 }}>
                                                    {this.state.Product.ProductLineDesc || this.state.Product.ProductLine}
                                                </span>
                                            )}
                                            {/* Last Sale */}
                                            {this.state.Product.LastDueDate && (
                                                <span style={{ background: 'rgba(245,158,11,0.2)', border: '1px solid rgba(245,158,11,0.4)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 600 }}>
                                                    Last sale: {new Date(this.state.Product.LastDueDate).toLocaleDateString()}
                                                </span>
                                            )}
                                        </div>

                                        {/* Product name */}
                                        <h3 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 700, fontSize: '1.25rem', margin: 0, lineHeight: 1.3 }}>
                                            {(this.state.Product.completeDesc && this.state.Product.completeDesc !== 'null')
                                                ? this.state.Product.completeDesc
                                                : this.state.Product.abbreviatedDesc}
                                        </h3>
                                    </div>

                                    <div className="card-body" style={{ padding: '1.75rem 2rem' }}>

                                        {/* ── Financial info row (read-only display) ── */}
                                        {(this.state.Product.LastTotalUnitCost || this.state.Product.UnitPrice) && (
                                            <div className="row g-3 mb-4">
                                                {this.state.Product.LastTotalUnitCost > 0 && (
                                                    <div className="col-auto">
                                                        <div style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '0.75rem 1.25rem' }}>
                                                            <p style={{ fontSize: '0.7rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.4px', margin: '0 0 2px' }}>Unit Cost</p>
                                                            <p style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0F172A', margin: 0 }}>${pricesFormat(this.state.Product.LastTotalUnitCost)}</p>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.Product.UnitPrice > 0 && (
                                                    <div className="col-auto">
                                                        <div style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '0.75rem 1.25rem' }}>
                                                            <p style={{ fontSize: '0.7rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.4px', margin: '0 0 2px' }}>Unit Price</p>
                                                            <p style={{ fontSize: '1.1rem', fontWeight: 700, color: '#2563EB', margin: 0 }}>${pricesFormat(this.state.Product.UnitPrice)}</p>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.Product.ShipWeight > 0 && (
                                                    <div className="col-auto">
                                                        <div style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '0.75rem 1.25rem' }}>
                                                            <p style={{ fontSize: '0.7rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.4px', margin: '0 0 2px' }}>Ship Weight</p>
                                                            <p style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0F172A', margin: 0 }}>{this.state.Product.ShipWeight} lbs</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className="row g-4">

                                            {/* ── Identifiers section ── */}
                                            <div className="col-md-6">
                                                <p style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '1rem', borderBottom: '1px solid #E2E8F0', paddingBottom: '0.5rem' }}>
                                                    Identifiers
                                                </p>
                                                <Field label="UPC" id="UPCInventoryInfo" defaultValue={this.state.Product.upc || ''} disabled={!isSergio} />
                                                <Field label="UPC 2" id="UPC2InventoryInfo" defaultValue={this.state.Product.upc2 || ''} disabled={!isSergio} />
                                                <Field label="Case UPC" id="CaseUPCInventoryInfo" defaultValue={this.state.Product.caseupc || ''} disabled={!isSergio} />
                                                <Field label="Unit of Measure" id="ItemUM" defaultValue="" />

                                                {isSergio && (
                                                    <button
                                                        type="button"
                                                        onClick={() => this.onKeyDown()}
                                                        style={{
                                                            marginTop: '0.75rem', background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                                            border: 'none', borderRadius: '10px', color: 'white', padding: '0.75rem 1.5rem',
                                                            fontWeight: 600, fontSize: '0.9375rem', cursor: 'pointer',
                                                            display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'center',
                                                        }}
                                                    >
                                                        <AiOutlineSave /> Save Changes
                                                    </button>
                                                )}
                                            </div>

                                            {/* ── Physical details section ── */}
                                            <div className="col-md-6">
                                                <p style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '1rem', borderBottom: '1px solid #E2E8F0', paddingBottom: '0.5rem' }}>
                                                    Physical Details
                                                </p>
                                                {/* Weight comes from ShipWeight — pre-filled */}
                                                <Field label="Weight" id="Itemweight" type="number" suffix="lbs" defaultValue={this.state.Product.ShipWeight || ''} />
                                                <Field label="Length" id="ItemLength" type="number" suffix="in" defaultValue="" />
                                                <Field label="Height" id="ItemHeight" type="number" suffix="in" defaultValue="" />
                                                <Field label="Width"  id="ItemWidth"  type="number" suffix="in" defaultValue="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )}

                </div>
            </div>
        );
    }
}
